// store/plugins/initProductType.js
export default function initProductTypePlugin(store) {
    // 监听 store 初始化
    store.subscribe((mutation, state) => {
        // 当用户登录成功时（根据实际 mutation 名称调整）
        if (mutation.type === "auth/SET_USER") {
            // 产品类型
            this.$store.dispatch("common/getProductType", "IOV_PRODUCT_TYPE");
            // 分公司树状结构
            this.$store.dispatch("common/getCompanyTree");
            // 租户城市信息
            this.$store.dispatch("common/getCurrentTenantArea");
        }
    });

    // 页面刷新时检查
    if (store.getters["auth/isAuthenticated"]) {
        // 产品类型
        !store.getters["common/hasProductType"] &&
            this.$store.dispatch("common/getProductType", "IOV_PRODUCT_TYPE");
        // 分公司树状结构
        !store.getters["common/hasCompanyTree"] &&
            this.$store.dispatch("common/getCompanyTree");
        // 租户城市信息
        !store.getters["common/hasCurrentTenantArea"] &&
            this.$store.dispatch("common/getCurrentTenantArea");
    }
}
